export const KANBAN_COLUMN_DEFINITIONS = [
	{ id: "unAssigned", title: "Unassigned" },
	{ id: "todo", title: "TODO" },
	{ id: "inProgress", title: "In Progress" },
	{ id: "done", title: "Done" },
	// { id: "delayed", title: "Delayed" },
];

export const ALL_KANBAN_COLUMN_IDS = KANBAN_COLUMN_DEFINITIONS.map((c) => c.id);

export const KANBAN_COLUMNS_STORAGE_KEY = "tasksKanbanVisibleColumns";

export function loadVisibleKanbanColumnIds() {
	try {
		const stored = JSON.parse(localStorage.getItem(KANBAN_COLUMNS_STORAGE_KEY));
		if (Array.isArray(stored)) {
			const filtered = stored.filter((id) =>
				ALL_KANBAN_COLUMN_IDS.includes(id),
			);
			if (filtered.length) return filtered;
		}
	} catch {}
	return ALL_KANBAN_COLUMN_IDS;
}
